// extracted by mini-css-extract-plugin
module.exports = {"button":"primary-button-module--button--tl8tY","disabled":"primary-button-module--disabled--svy32"};